import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import 'styles/_deliveryform.scss';

class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      showDecline: true
    };
  }

  closeVideo = () => {
    this.props.closeVideo();
  };

  render() {
    return (
      <Modal size="lg" isOpen={this.props.isOpen} aria-labelledby="modal-title">
        <ModalHeader tag="div">
          <h2 id="modal-title">Walk the Path</h2>
        </ModalHeader>
        <ModalBody>
          <div>
            <Link
              to="/tracking_measure"
              onClick={this.closeVideo}
              className="float-right"
              role="button" 
              aria-label="Close"             
            >
              {' '}
              [X]{' '}
            </Link>
          </div>
          <div>
            <iframe
              tabIndex={0}
              className='video-modal-iframe'
              title="Video"
              src="https://www.youtube.com/embed/w9G5Z6R5TSA?autoplay=1"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; disablekb=0"
              allowfullscreen="true"
              webkitallowfullscreen="true" 
              alt="Video is not avaialable"
            />
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
export default VideoModal;
